module.exports = function() {
  return new Worker(__webpack_public_path__ + "2389ffe4b437aff29708.worker.js");
};